import Column from "./default"
import checkOnPng from "../../../img/launch.png"
import { isMobile } from "../../utils"

const checkOnImg = new Image()
checkOnImg.src = checkOnPng
export default class IconColumn extends Column {
	get cursor () {
		return "pointer"
	}

	constructor ({ options }) {
		super({ options })
	}

	onCellEdit (ctx, setValue) {
		if (!isMobile) {
			ctx.controlEl.focus()
		}
	}

	renderCell (ctx, {
		offsetTop,
		offsetLeft,
		height,
		cellInfo
	}) {
		ctx.useContext2d(ctx2d => {
			// セル描画
			ctx2d.strokeStyle = ctx.gridStyle.borderColor
			ctx2d.lineWidth = ctx.gridStyle.borderLineWidth
			ctx2d.fillStyle = ctx.gridStyle.bgColor
			if (cellInfo) {
				ctx2d.fillStyle = cellInfo.bgColor || ctx2d.fillStyle
			}
			ctx.fillRect(offsetLeft, offsetTop, this.actualWidth, height)
			ctx.strokeRect(offsetLeft, offsetTop, this.actualWidth, height)

			const iconSize = this.options.fontSize || ctx.fontSize

			const img = checkOnImg
			const paddingLeft = (this.actualWidth - iconSize) / 2
			const paddingTop = (height - iconSize) / 2
			ctx.drawImage(img, offsetLeft + paddingLeft, offsetTop + paddingTop, iconSize, iconSize)
		})
	}
}
